import React, { useEffect, useState } from 'react'
import ConfigureSlotModal from '../modals/ConfigureSlotModal';
import { Add } from '@mui/icons-material';
import Forward from './Forward';
import RingBrowser from './RingBrowser';
import ForwardVM from './ForwardVM';
import PrimaryIvrMenu from './IvrMenu';
import OffHoursIvrMenu from './OffHoursIvrMenu';
import OffHoursForward from './OffHoursForward';
import OffHoursForwardVM from './OffHoursForwardVM';
import OffHoursDynamicForward from './OffHoursDynamicForward';
import { DYNAMIC_FORWARD_OFF_HOURS_SLOT_DEFAULTS } from '../../hooks/useCallAction';
import SendToVoicemail from './SendToVoicemail';
import PlayRecording from './PlayRecording';
import ElevenLabs from './ElevenLabs';

const OffHoursCallAction = ({
    route,
    setRoute,
    setSnackMsg,
    setOpenSnack,
    setLoader,
    enableBusinessHours = false,
    hasValidationError = false,
  }) => {


    const [openConfigureSlotModal, setOpenConfigureSlotModal] = useState(false)
    const [slot, setSlot] = useState(null)



    useEffect(()=> {

        if(slot == 'ivr'){
            setRoute({...route, offHoursAction: 'ivr', offHoursIvrMenu : {
                options: {
                    "1": {
                        digit: "1",
                        id: "press_1",
                        name: "Press 1",
                        primaryAction: null,
                        notification: null,
                      },
                },
            }})
        }

        if(slot =='forward'){
                setRoute({...route, offHoursAction: slot , primaryChannel:null, ringTarget:null, ringGroup: null , ringUser: null, offHoursIvrMenu: null,})
        }

        if(slot =='ring_browser'){
            setRoute({...route, offHoursAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, offHoursIvrMenu: null})
    }

    if(slot =='forwardvwm'){
        setRoute({...route, offHoursAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, offHoursIvrMenu: null,ringGroup: null , ringUser: null,})
}

    if(slot =='dynamic_forward'){
        setRoute({...route, offHoursAction: slot , primaryChannel:null, primaryNumber: null, offHoursIvrMenu: null, ringGroup: null, ringUser: null, ...DYNAMIC_FORWARD_OFF_HOURS_SLOT_DEFAULTS})
    }

    if(slot =='send_to_vm'){
        setRoute({...route, offHoursAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, offHoursIvrMenu: null, ringGroup: null, ringUser: null})
    }

    if(slot =='play_recording'){
        setRoute({...route, offHoursAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, offHoursIvrMenu: null, ringGroup: null, ringUser: null})
    }

    if(slot =='ai_agent'){
        setRoute({...route, offHoursAction: slot , primaryChannel:null, primaryNumber: null, callerIdPref: null, offHoursIvrMenu: null, ringGroup: null, ringUser: null})
    }

    }, [slot])
  return (
    <div className="  w-full">
          

          <div className="text-[12px] font-semibold text-gray-500 mb-2">
              AFTER HOURS
          </div>

          <ConfigureSlotModal
            open={openConfigureSlotModal}
            onClose={setOpenConfigureSlotModal}
            slot={setSlot}
            route={route}
          />

          {!route?.offHoursAction && (
            <div className={`rounded-lg border border-gray-200 py-8 px-4 shadow-sm ${hasValidationError ? "bg-red-50/80" : "bg-white"}`}>
              <div
                className="border-2 border-dashed border-gray-300 rounded-lg cursor-pointer 
                     flex items-center justify-center h-16 hover:border-gray-400 transition"
                onClick={() => setOpenConfigureSlotModal(true)}
              >
                <Add className="text-gray-500 mr-2" />
                <span className="text-gray-600">Add Call Action</span>
              </div>
            </div>
          )}

{route?.offHoursAction == "ivr" && (
           <OffHoursIvrMenu route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} enableBusinessHours={enableBusinessHours} />
          )}

          {route?.offHoursAction == "forward" && (
           <OffHoursForward route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          {/* {route?.offHoursAction == "ring_browser" && (
           <RingBrowser route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal}  /> 
          )} */}

          {route?.offHoursAction == "forwardvwm" && (
           <OffHoursForwardVM route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          {route?.offHoursAction == "dynamic_forward" && (
           <OffHoursDynamicForward route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} hasValidationError={hasValidationError} /> 
          )}

          {route?.offHoursAction == "send_to_vm" && (
           <SendToVoicemail route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} context="offHours" hasValidationError={hasValidationError} /> 
          )}

          {route?.offHoursAction == "play_recording" && (
           <PlayRecording route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} context="offHours" hasValidationError={hasValidationError} /> 
          )}

          {route?.offHoursAction == "ai_agent" && (
           <ElevenLabs route={route} setRoute={setRoute} setOpenConfigureSlotModal={setOpenConfigureSlotModal} context="offHours" hasValidationError={hasValidationError} /> 
          )}

          
        </div>
  )
}

export default OffHoursCallAction